__turbopack_context__.v({
  "acheiverrank": "modal-module__MmyzJG__acheiverrank",
  "finalmodalbtn": "modal-module__MmyzJG__finalmodalbtn",
  "normalbutton": "modal-module__MmyzJG__normalbutton",
  "otpTitleVer": "modal-module__MmyzJG__otpTitleVer",
  "otpinputfield": "modal-module__MmyzJG__otpinputfield",
  "otpinputfieldarea": "modal-module__MmyzJG__otpinputfieldarea",
});
